<template>
    <div>
        <div class="loader" v-if="this.isLoading"></div>
        <div class="loadertext" v-if="this.isLoading"> {{ $t('loadingTxt') }}...</div>
        <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">

            <!--begin::navbar-->
            <navbar-component></navbar-component>
            <!--end::navbar-->

            <div class="page-wrapper">

                <!--begin::content-->
                <div class="page-content">
                    <div class="row">
                        <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                            <div class="card">
                                <div class="card-header">
                                    <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                                    &nbsp;&nbsp;&nbsp;
                                    <h6 class="card-title mb-0 float-start" style="padding-left: 25px">Edit SO</h6>
                                    <button class="btn btn-default btn-sm float-end" @click="resetForm" type="button">
                                        <i class="link-icon" data-feather="repeat"></i>
                                        {{ $t("resetFormTxt") }}
                                    </button>
                                </div>
                                <div class="card-body">

                                    <form class="forms-sample" @submit.prevent="submitData" method="POST">


                                        <ul class="nav nav-tabs nav-tabs-line" id="lineTab" role="tablist">
                                            <li class="nav-item">
                                                <a class="nav-link active" id="home-line-tab" data-bs-toggle="tab"
                                                    href="#home" role="tab" aria-controls="home" aria-selected="true">Main
                                                    Info</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" id="consignee-line-tab" data-bs-toggle="tab"
                                                    href="#consignee" role="tab" aria-controls="consignee"
                                                    aria-selected="false">Consignee</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" id="carrier-line-tab" data-bs-toggle="tab"
                                                    href="#carrier" role="tab" aria-controls="disabled"
                                                    aria-selected="false">Carrier</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" id="udf-line-tab" data-bs-toggle="tab" href="#udf"
                                                    role="tab" aria-controls="disabled" aria-selected="false">User
                                                    Defined</a>
                                            </li>


                                            <li class="nav-item">
                                                <a class="nav-link" id="other-line-tab" data-bs-toggle="tab" href="#other"
                                                    role="other" aria-controls="disabled" aria-selected="false">Other</a>
                                            </li>

                                        </ul>
                                        <div class="tab-content mt-3" id="lineTabContent">
                                            <div class="tab-pane fade show active" id="home" role="tabpanel"
                                                aria-labelledby="home-line-tab">

                                                <div class="row mb-2">
                                                    <div class="col-lg-4">
                                                        <label for="defaultconfig" class="col-form-label required">{{
                                                            $t('customerId')
                                                        }}</label>

                                                        <v-select :options="fetchCustomer" v-model="customer" label="code"
                                                            return-object @search="asyncCustomer">
                                                            <template slot="option" slot-scope="option">
                                                                {{ option.code }} | {{ option.name }}
                                                            </template>
                                                        </v-select>

                                                        <div v-if="errors.customerId">
                                                            <div v-for="error in errors.customerId" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div class="col-lg-4">
                                                        <label for="defaultconfig" class="col-form-label required">Warehouse
                                                            Id</label>

                                                        <v-select :options="fetchFulfillment" v-model="fulfillment"
                                                            label="code" return-object @search="asyncSearchFulfillment">
                                                            <template slot="option" slot-scope="option">
                                                                {{ option.code }} | {{ option.name }}
                                                            </template>
                                                        </v-select>


                                                        <div v-if="errors.fulfillment_center_id">
                                                            <div v-for="error in errors.fulfillment_center_id" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div class="col-lg-4">
                                                        <label for="defaultconfig" class="col-form-label required">Order
                                                            Type</label>

                                                        <v-select :options="fetchOrderType" v-model="orderType" label="name"
                                                            return-object>
                                                            <!-- <template slot="option" slot-scope="option">
                  {{ option.customer_id}} | {{option.code}} | {{option.name}}
            </template> -->
                                                        </v-select>
                                                        <div v-if="errors.orderType">
                                                            <div v-for="error in errors.orderType" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>

                                                <div class="row mb-2">
                                                    <div class="col-lg-3">
                                                        <label for="defaultconfig" class="col-form-label required">Order
                                                            Time</label>
                                                        <date-range-picker style="width: 100%"
                                                            control-container-class="form-control" :locale-data="locale"
                                                            v-model="dateFilter" :opens="opens" :singleDatePicker="true"
                                                            :timePicker24Hour="true" :timePicker="true"
                                                            :showWeekNumbers="false">
                                                        </date-range-picker>
                                                        <div v-if="errors.orderTime">
                                                            <div v-for="error in errors.orderTime" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div class="col-lg-3">

                                                        <label for="defaultconfig" class="col-form-label">Expected Shipment
                                                            Time</label>
                                                        <date-range-picker style="width: 100%"
                                                            control-container-class="form-control" :locale-data="locale"
                                                            v-model="expectedShipmentTime1dateFilter" :opens="opens"
                                                            :singleDatePicker="true" :timePicker24Hour="true"
                                                            :timePicker="true" :showWeekNumbers="false">
                                                        </date-range-picker>
                                                        <div v-if="errors.expectedShipmentTime1">
                                                            <div v-for="error in errors.expectedShipmentTime1" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>

                                                    </div>


                                                    <div class="col-lg-3">
                                                        <label for="defaultconfig" class="col-form-label">Channel</label>
                                                        <input type="text" class="form-control" id="channel"
                                                            placeholder="Chanel" v-model="forms.channel" />
                                                        <div v-if="errors.channel">
                                                            <div v-for="error in errors.channel" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div class="col-lg-3">
                                                        <label for="defaultconfig" class="col-form-label">Delivery
                                                            No</label>
                                                        <input type="text" class="form-control" id="delivery"
                                                            placeholder="Delivery No" v-model="forms.deliveryNo" />
                                                        <div v-if="errors.deliveryNo">
                                                            <div v-for="error in errors.deliveryNo" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                                <div class="row mb-2">
                                                    <div class="col-lg-4">
                                                        <label for="defaultconfig" class="col-form-label required">Doc
                                                            No</label>
                                                        <input type="text" class="form-control" id="orderNo"
                                                            placeholder="Doc No" v-model="forms.docNo" />
                                                        <div v-if="errors.docNo">
                                                            <div v-for="error in errors.docNo" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">So Reference
                                                            A</label>
                                                        <input type="text" class="form-control" id="stopStation"
                                                            placeholder="So Reference A" v-model="forms.soReferenceA" />
                                                        <div v-if="errors.soReferenceA">
                                                            <div v-for="error in errors.soReferenceA" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>

                                                    </div>



                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">So Reference
                                                            B</label>
                                                        <input type="text" class="form-control" id="soReferenceB"
                                                            placeholder="SO Reference B" v-model="forms.soReferenceB" />
                                                        <div v-if="errors.soReferenceB">
                                                            <div v-for="error in errors.soReferenceB" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">So Reference
                                                            C</label>
                                                        <input type="text" class="form-control" id="soReferenceC"
                                                            placeholder="SO Reference C" v-model="forms.soReferenceC" />
                                                        <div v-if="errors.soReferenceC">
                                                            <div v-for="error in errors.soReferenceC" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">So Reference
                                                            D</label>
                                                        <input type="text" class="form-control" id="soReferenceD"
                                                            placeholder="SO Reference D" v-model="forms.soReferenceD" />
                                                        <div v-if="errors.soReferenceD">
                                                            <div v-for="error in errors.soReferenceD" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- <div class="col-lg-3">
        <label for="defaultconfig" class="col-form-label required">Customer Ref No</label>
        <input type="text" class="form-control" id="customerRefNo" placeholder=""
          v-model="forms.customerRefNo" />
        <div v-if="errors.customerRefNo">
          <div v-for="error in errors.customerRefNo" :key="error" class="alert alert-primary"
            role="alert">
            <i data-feather="alert-circle"></i>
            {{ error }}
          </div>
        </div>
      </div> -->
                                                    <!-- <div class="col-lg-3">
        <label for="defaultconfig" class="col-form-label">Buyer Ref No</label>
        <input type="text" class="form-control" id="buyerRefNo" placeholder=""
          v-model="forms.buyerRefNo" />
        <div v-if="errors.buyerRefNo">
          <div v-for="error in errors.buyerRefNo" :key="error" class="alert alert-primary"
            role="alert">
            <i data-feather="alert-circle"></i>
            {{ error }}
          </div>
        </div>
      </div> -->
                                                    <!-- <div class="col-lg-3">
        <label for="defaultconfig" class="col-form-label">Tms Load Id</label>
        <input type="text" class="form-control" id="tmsLoadId" placeholder=""
          v-model="forms.tmsLoadId" />
        <div v-if="errors.tmsLoadId">
          <div v-for="error in errors.tmsLoadId" :key="error" class="alert alert-primary"
            role="alert">
            <i data-feather="alert-circle"></i>
            {{ error }}
          </div>
        </div>
      </div> -->
                                                </div>

                                                <!--<div class="row mb-2">
        <div class="col-lg-2">
          <label for="defaultconfig" class="col-form-label">Route</label>
          <input type="text" class="form-control" id="route" placeholder="Route"
            v-model="forms.route" />
          <div v-if="errors.route">
            <div v-for="error in errors.route" :key="error" class="alert alert-primary" role="alert">
              <i data-feather="alert-circle"></i>
              {{ error }}
            </div>
          </div>

        </div>
        <div class="col-lg-2">
          <label for="defaultconfig" class="col-form-label">Stop Station</label>
          <input type="text" class="form-control" id="stopStation" placeholder="Stop Station"
            v-model="forms.stopStation" />
          <div v-if="errors.stopStation">
            <div v-for="error in errors.stopStation" :key="error" class="alert alert-primary"
              role="alert">
              <i data-feather="alert-circle"></i>
              {{ error }}
            </div>
          </div>

        </div>
    </div>-->





                                                <div class="row mb-2">



                                                </div>


                                                <div class="row mb-2">
                                                    <div class="col-lg-12">
                                                        <label for="defaultconfig" class="col-form-label">Note</label>
                                                        <textarea class="form-control" name="noteTxt"
                                                            v-model="forms.noteText"></textarea>
                                                        <div v-if="errors.noteText">
                                                            <div v-for="error in errors.noteText" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                                <div class="row card mt-5">
                                                    <div class="card-header">
                                                        <h5 class="float-start">Detail <span class="wajib">*</span></h5>

                                                        <button class="
        btn btn-success btn-icon
        text-white
        fw-bolder
        btn-icon-text
        float-end
      " @click="addFieldDetail()" type="button"> <i class="link-icon" data-feather="plus"></i>
                                                        </button>

                                                    </div>

                                                    <div class="card-body">
                                                        <div class="table-responsive">
                                                            <table class="table table-hover" style="height: 300px">
                                                                <thead>

                                                                    <tr>
                                                                        <th>#</th>
                                                                        <th width="450px" class="required">SKU</th>
                                                                        <th width="150px">SKU Description</th>
                                                                        <th class="required">Qty Order</th>
                                                                        <th>Uom</th>
                                                                        <th>Price</th>
                                                                        <th>lotAtt01</th>
                                                                        <th>lotAtt02</th>
                                                                        <th>lotAtt03</th>
                                                                        <th>lotAtt04</th>
                                                                        <th>lotAtt05</th>
                                                                        <th>lotAtt06</th>
                                                                        <th>lotAtt07</th>
                                                                        <th>lotAtt08</th>
                                                                        <th>lotAtt09</th>
                                                                        <th>lotAtt10</th>
                                                                        <th>lotAtt11</th>
                                                                        <th>lotAtt12</th>
                                                                        <th>lotAtt13</th>
                                                                        <th>lotAtt14</th>
                                                                        <th>lotAtt15</th>
                                                                        <th>lotAtt16</th>
                                                                        <th>lotAtt17</th>
                                                                        <th>lotAtt18</th>
                                                                        <th>lotAtt19</th>
                                                                        <th>lotAtt20</th>
                                                                        <th>lotAtt21</th>
                                                                        <th>lotAtt22</th>
                                                                        <th>lotAtt23</th>
                                                                        <th>lotAtt24</th>
                                                                        <th>Udf01</th>
                                                                        <th>Udf02</th>
                                                                        <th>Udf03</th>
                                                                        <th>Udf04</th>
                                                                        <th>Udf05</th>
                                                                        <th>Udf06</th>
                                                                        <th>Dedi01</th>
                                                                        <th>Dedi02</th>
                                                                        <th>Dedi03</th>
                                                                        <th>Dedi04</th>
                                                                        <th>Dedi05</th>
                                                                        <th>Dedi06</th>
                                                                        <th>Dedi07</th>
                                                                        <th>Dedi08</th>
                                                                        <th>Dedi09</th>
                                                                        <th>Dedi10</th>
                                                                        <th>Dedi11</th>
                                                                        <th>Dedi12</th>
                                                                        <th>Dedi13</th>
                                                                        <th>Dedi14</th>
                                                                        <th>Dedi15</th>
                                                                        <th>Dedi16</th>
                                                                        <th>Dedi17</th>
                                                                        <th>Dedi18</th>
                                                                        <th>Dedi19</th>
                                                                        <th>Dedi20</th>
                                                                        <th>Rotation Id</th>
                                                                        <th>Note Text</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(input, index) in this.detailSo"
                                                                        :key="`phoneInput-${index}`">
                                                                        <th>{{ index + 1 }}</th>

                                                                        <td width="200px">


                                                                            <multiselect style="width:200px;"
                                                                                @search-change="asyncSearchSku"
                                                                                v-model="input.sku" :options="fetchSku"
                                                                                @input="cekData(index, detailSo)"
                                                                                label="sku" track-by="sku"
                                                                                placeholede="Please Select SKU">
                                                                                <span slot="noResult">Oops! No elements
                                                                                    found. Consider changing the
                                                                                    search query.</span>
                                                                            </multiselect>


                                                                        </td>

                                                                        <td>

                                                                            {{ input.skuDescr1 }}
                                                                            <!-- <input type="number" v-model="input.volume" class="form-control" style="width: 100px" /> -->
                                                                        </td>

                                                                        <td>
                                                                            <input type="number" v-model="input.qtyOrdered"
                                                                                class="form-control" step="any" required
                                                                                style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.uom"
                                                                                class="form-control" style="width: 100px" />

                                                                        </td>



                                                                        <!-- <td>
                  <input type="text" v-mask="'####-##-##'" placeholder="YYYY-MM-DD" v-model="input.ProdDate" class="form-control" style="width: 150px"/>
                
                </td>


                <td>
                  <input type="text" v-model="input.WhseDate" class="form-control"
                    style="width: 100px" />
                  
                </td>

                <td>
                  <input type="text" v-mask="'####-##-##'" placeholder="YYYY-MM-DD" v-model="input.ExpDate" class="form-control" style="width: 150px"/>
                
                </td> -->


                                                                        <td>
                                                                            <input type="number" v-model="input.price"
                                                                                class="form-control" step="any" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt01"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt02"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt03"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt04"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt05"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt06"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt07"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>



                                                                        <td>



                                                                            <multiselect style="width:200px;"
                                                                                v-model="input.lotAtt08"
                                                                                :options="fetchStockCondition" label="name"
                                                                                track-by="name" placeholede="Please Select">
                                                                                <span slot="noResult">Oops! No elements
                                                                                    found. Consider changing the
                                                                                    search query.</span>
                                                                            </multiselect>

                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt09"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>



                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt10"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt11"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt12"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt13"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt14"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt15"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt16"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt17"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt18"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt19"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt20"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt21"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt22"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt23"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.lotAtt24"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.udf01"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.udf02"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.udf03"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.udf04"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.udf05"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.udf06"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.dedi01"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.dedi02"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.dedi03"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.dedi04"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.dedi05"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.dedi06"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.dedi07"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.dedi08"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="number" step="any"  v-model="input.dedi09"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="number" step="any" v-model="input.dedi10"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.dedi11"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.dedi12"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.dedi13"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.dedi14"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.dedi15"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.dedi16"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.dedi17"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.dedi18"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.dedi19"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>


                                                                        <td>
                                                                            <input type="text" v-model="input.dedi20"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>
                                                                            <input type="text" v-model="input.rotationId"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>





















                                                                        <td>
                                                                            <input type="text" v-model="input.noteText"
                                                                                class="form-control" style="width: 100px" />
                                                                        </td>

                                                                        <td>


                                                                            <!--          Remove Svg Icon-->
                                                                            <svg @click="removeField(index, detailSo)"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                viewBox="0 0 24 24" width="24" height="24"
                                                                                class="ml-2 cursor-pointer">
                                                                                <path fill="none" d="M0 0h24v24H0z" />
                                                                                <path fill="red"
                                                                                    d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z" />
                                                                            </svg>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>

                                                                <tfoot></tfoot>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                            <div class="tab-pane fade" id="consignee" role="tabpanel"
                                                aria-labelledby="consignee-line-tab">
                                                <div class="row mb-2">
                                                    <div class="col-lg-3">
                                                        <label for="defaultconfig" class="col-form-label required">Consignee
                                                            Id</label>
                                                        <input type="text" class="form-control" id="consigneeId"
                                                            placeholder="Consignee ID" v-model="forms.consigneeId" />

                                                        <div v-if="errors.consigneeId">
                                                            <div v-for="error in errors.consigneeId" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div class="col-lg-4">
                                                        <label for="defaultconfig" class="col-form-label required">Consignee
                                                            Name</label>
                                                        <input type="text" class="form-control" id="consigneeName"
                                                            placeholder="Consignee Name" v-model="forms.consigneeName" />

                                                        <div v-if="errors.consigneeName">
                                                            <div v-for="error in errors.consigneeName" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-5">
                                                        <label for="defaultconfig" class="col-form-label">Consignee
                                                            Email</label>
                                                        <input type="text" class="form-control" id="consigneeemail"
                                                            placeholder="Consignee Name" v-model="forms.consigneeEmail" />

                                                        <div v-if="errors.consigneeEmail">
                                                            <div v-for="error in errors.consigneeEmail" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div class="row mb-2">
                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Country</label>
                                                        <input type="text" class="form-control" id="consigneeCountry"
                                                            placeholder="Consignee Name" v-model="forms.consigneeCountry" />

                                                        <div v-if="errors.consigneeCountry">
                                                            <div v-for="error in errors.consigneeCountry" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Province</label>
                                                        <input type="text" class="form-control" id="consigneeProvince"
                                                            placeholder="Consignee Name"
                                                            v-model="forms.consigneeProvince" />

                                                        <div v-if="errors.consigneeProvince">
                                                            <div v-for="error in errors.consigneeProvince" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">City</label>
                                                        <input type="text" class="form-control" id="consigneeCity"
                                                            placeholder="Consignee Name" v-model="forms.consigneeCity" />

                                                        <div v-if="errors.consigneeCity">
                                                            <div v-for="error in errors.consigneeCity" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">District</label>
                                                        <input type="text" class="form-control" id="consigneeDistrict"
                                                            placeholder="Consignee Name"
                                                            v-model="forms.consigneeDistrict" />

                                                        <div v-if="errors.consigneeDistrict">
                                                            <div v-for="error in errors.consigneeDistricty" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Street</label>
                                                        <input type="text" class="form-control" id="consigneeStreet"
                                                            placeholder="Consignee Name" v-model="forms.consigneeStreet" />

                                                        <div v-if="errors.consigneeStreet">
                                                            <div v-for="error in errors.consigneeStreet" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Zip</label>
                                                        <input type="text" class="form-control" id="consigneeZip"
                                                            placeholder="Consignee Name" v-model="forms.consigneeZip" />

                                                        <div v-if="errors.consigneeZip">
                                                            <div v-for="error in errors.consigneeZip" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div class="row mb-2">
                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label required">Phone
                                                            1</label>
                                                        <input type="text" class="form-control" id="consigneeTel1"
                                                            placeholder="Consignee Phone 1" v-model="forms.consigneeTel1" />

                                                        <div v-if="errors.consigneeTel1">
                                                            <div v-for="error in errors.consigneeTel1" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Phone 2</label>
                                                        <input type="text" class="form-control" id="consigneeTel2"
                                                            placeholder="Consignee Phone 2" v-model="forms.consigneeTel2" />

                                                        <div v-if="errors.consigneeTel2">
                                                            <div v-for="error in errors.consigneeTel2" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Contact</label>
                                                        <input type="text" class="form-control" id="consigneeContact"
                                                            placeholder="Consignee Contact"
                                                            v-model="forms.consigneeContact" />

                                                        <div v-if="errors.consigneeContact">
                                                            <div v-for="error in errors.consigneeContact" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-6">
                                                        <label for="defaultconfig" class="col-form-label required">Consignee
                                                            Address 1</label>
                                                        <input type="text" class="form-control" id="consigneeAddress21"
                                                            placeholder="Address" v-model="forms.consigneeAddress1" />

                                                        <div v-if="errors.consigneeAddress1">
                                                            <div v-for="error in errors.consigneeAddress1" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>




                                                </div>

                                                <div class="row mb-2">
                                                    <div class="col-lg-4">
                                                        <label for="defaultconfig" class="col-form-label">Consignee Address
                                                            2</label>
                                                        <input type="text" class="form-control" id="consigneeAddress2"
                                                            placeholder="Address" v-model="forms.consigneeAddress2" />

                                                        <div v-if="errors.consigneeAddress2">
                                                            <div v-for="error in errors.consigneeAddress2" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-4">
                                                        <label for="defaultconfig" class="col-form-label">Consignee Address
                                                            3</label>
                                                        <input type="text" class="form-control" id="consigneeAddress3"
                                                            placeholder="Address" v-model="forms.consigneeAddress3" />

                                                        <div v-if="errors.consigneeAddress3">
                                                            <div v-for="error in errors.consigneeAddress3" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>



                                                    <div class="col-lg-4">
                                                        <label for="defaultconfig" class="col-form-label">Consignee Address
                                                            4</label>
                                                        <input type="text" class="form-control" id="consigneeAddress4"
                                                            placeholder="Address" v-model="forms.consigneeAddress4" />

                                                        <div v-if="errors.consigneeAddress4">
                                                            <div v-for="error in errors.consigneeAddress4" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>









                                            </div>

                                            <div class="tab-pane fade" id="udf" role="tabpanel"
                                                aria-labelledby="udf-line-tab">

                                                <div class="row mb-3">
                                                    <div class="col-lg-4">
                                                        <label for="defaultconfig" class="col-form-label">UDF 1</label>
                                                        <input type="text" class="form-control" id="udf1" placeholder=""
                                                            v-model="forms.userDefine1" />
                                                        <div v-if="errors.userDefine1">
                                                            <div v-for="error in errors.userDefine1" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-4">
                                                        <label for="defaultconfig" class="col-form-label">UDF 2</label>
                                                        <input type="text" class="form-control" id="udf2" placeholder=""
                                                            v-model="forms.userDefine2" />
                                                        <div v-if="errors.userDefine2">
                                                            <div v-for="error in errors.udf2" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-4">
                                                        <label for="defaultconfig" class="col-form-label">UDF 3</label>
                                                        <input type="text" class="form-control" id="udf3" placeholder=""
                                                            v-model="forms.userDefine3" />
                                                        <div v-if="errors.userDefine3">
                                                            <div v-for="error in errors.userDefine3" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="row mb-3">
                                                    <div class="col-lg-4">
                                                        <label for="defaultconfig" class="col-form-label">UDF 4</label>
                                                        <input type="text" class="form-control" id="udf4" placeholder=""
                                                            v-model="forms.userDefine4" />
                                                        <div v-if="errors.userDefine4">
                                                            <div v-for="error in errors.userDefine4" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-4">
                                                        <label for="defaultconfig" class="col-form-label">UDF 5</label>
                                                        <input type="text" class="form-control" id="udf5" placeholder=""
                                                            v-model="forms.userDefine5" />
                                                        <div v-if="errors.userDefine5">
                                                            <div v-for="error in errors.userDefine5" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-4">
                                                        <label for="defaultconfig" class="col-form-label">UDF 6</label>
                                                        <input type="text" class="form-control" id="udf6" placeholder=""
                                                            v-model="forms.userDefine6" />
                                                        <div v-if="errors.userDefine6">
                                                            <div v-for="error in errors.userDefine6" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>



                                            <div class="tab-pane fade show" id="carrier" role="tabpanel"
                                                aria-labelledby="carrier-line-tab">
                                                <div class="row mb-3">
                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Carrier Id</label>
                                                        <input type="text" class="form-control" id="carrierId"
                                                            placeholder="" v-model="forms.carrierId" />

                                                        <div v-if="errors.carrierId">
                                                            <div v-for="error in errors.carrierId" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Carrier
                                                            Name</label>
                                                        <input type="text" class="form-control" id="carrierName"
                                                            placeholder="" v-model="forms.carrierName" />

                                                        <div v-if="errors.carrierName">
                                                            <div v-for="error in errors.carrierName" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Carrier
                                                            Email</label>
                                                        <input type="text" class="form-control" id="carrierEmail"
                                                            placeholder="" v-model="forms.carrierEmail" />

                                                        <div v-if="errors.carrierEmail">
                                                            <div v-for="error in errors.carrierEmail" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Carrier
                                                            Contact</label>
                                                        <input type="text" class="form-control" id="carrierContact"
                                                            placeholder="" v-model="forms.carrierContact" />

                                                        <div v-if="errors.carrierContact">
                                                            <div v-for="error in errors.carrierContact" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Carrier
                                                            Fax</label>
                                                        <input type="text" class="form-control" id="carrierFax"
                                                            placeholder="" v-model="forms.carrierFax" />

                                                        <div v-if="errors.carrierFax">
                                                            <div v-for="error in errors.carrierFax" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Carrier Tel
                                                            1</label>
                                                        <input type="text" class="form-control" id="carrierTel1"
                                                            placeholder="" v-model="forms.carrierTel1" />

                                                        <div v-if="errors.carrierTel1">
                                                            <div v-for="error in errors.carrierTel1" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div class="row mb-3">

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Carrier Tel
                                                            2</label>
                                                        <input type="text" class="form-control" id="carrierTel1"
                                                            placeholder="" v-model="forms.carrierTel2" />

                                                        <div v-if="errors.carrierTel2">
                                                            <div v-for="error in errors.carrierTel2" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-4">
                                                        <label for="defaultconfig" class="col-form-label">Carrier Address
                                                            1</label>
                                                        <input type="text" class="form-control" id="carrierAddress1"
                                                            placeholder="" v-model="forms.carrierAddress1" />

                                                        <div v-if="errors.carrierAddress1">
                                                            <div v-for="error in errors.carrierAddress1" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Carrier Address
                                                            2</label>
                                                        <input type="text" class="form-control" id="carrierAddress2"
                                                            placeholder="" v-model="forms.carrierAddress2" />

                                                        <div v-if="errors.carrierAddress2">
                                                            <div v-for="error in errors.carrierAddress2" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Carrier Address
                                                            3</label>
                                                        <input type="text" class="form-control" id="carrierAddress3"
                                                            placeholder="" v-model="forms.carrierAddress3" />

                                                        <div v-if="errors.carrierAddress3">
                                                            <div v-for="error in errors.carrierAddress3" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Carrier Address
                                                            4</label>
                                                        <input type="text" class="form-control" id="carrierAddress4"
                                                            placeholder="" v-model="forms.carrierAddress4" />

                                                        <div v-if="errors.carrierAddress4">
                                                            <div v-for="error in errors.carrierAddress4" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>


                                                <div class="row mb-3">

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Carrier
                                                            Country</label>
                                                        <input type="text" class="form-control" id="carrierCountry"
                                                            placeholder="" v-model="forms.carrierCountry" />

                                                        <div v-if="errors.carrierCountry">
                                                            <div v-for="error in errors.carrierCountry" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Carrier
                                                            Province</label>
                                                        <input type="text" class="form-control" id="carrierProvince"
                                                            placeholder="" v-model="forms.carrierProvince" />

                                                        <div v-if="errors.carrierProvince">
                                                            <div v-for="error in errors.carrierProvince" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Carrier
                                                            City</label>
                                                        <input type="text" class="form-control" id="carrierCity"
                                                            placeholder="" v-model="forms.carrierCity" />

                                                        <div v-if="errors.carrierCity">
                                                            <div v-for="error in errors.carrierCity" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Carrier
                                                            District</label>
                                                        <input type="text" class="form-control" id="carrierDistrict"
                                                            placeholder="" v-model="forms.carrierDistrict" />

                                                        <div v-if="errors.carrierDistrict">
                                                            <div v-for="error in errors.carrierDistrict" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Carrier
                                                            Street</label>
                                                        <input type="text" class="form-control" id="carrierStreet"
                                                            placeholder="" v-model="forms.carrierStreet" />

                                                        <div v-if="errors.carrierStreet">
                                                            <div v-for="error in errors.carrierStreet" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Carrier
                                                            Zip</label>
                                                        <input type="text" class="form-control" id="carrierZip"
                                                            placeholder="" v-model="forms.carrierZip" />

                                                        <div v-if="errors.carrierZip">
                                                            <div v-for="error in errors.carrierZip" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>






                                            </div>

                                            <div class="tab-pane fade show" id="other" role="tabpanel"
                                                aria-labelledby="other-line-tab">
                                                <div class="row mb-3">
                                                    <div class="col-lg-3">
                                                        <label for="defaultconfig" class="col-form-label">Hedi01</label>
                                                        <input type="text" class="form-control" id="hedi01" placeholder=""
                                                            v-model="forms.hedi01" />

                                                        <div v-if="errors.hedi01">
                                                            <div v-for="error in errors.hedi01" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Hedi02</label>
                                                        <input type="text" class="form-control" id="hedi02" placeholder=""
                                                            v-model="forms.hedi02" />

                                                        <div v-if="errors.hedi02">
                                                            <div v-for="error in errors.hedi02" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Hedi03</label>
                                                        <input type="text" class="form-control" id="hedi02" placeholder=""
                                                            v-model="forms.hedi03" />

                                                        <div v-if="errors.hedi03">
                                                            <div v-for="error in errors.hedi03" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Hedi04</label>
                                                        <input type="text" class="form-control" id="hedi04" placeholder=""
                                                            v-model="forms.hedi04" />

                                                        <div v-if="errors.hedi04">
                                                            <div v-for="error in errors.hedi04" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-3">
                                                        <label for="defaultconfig" class="col-form-label">Hedi05</label>
                                                        <input type="text" class="form-control" id="hedi05" placeholder=""
                                                            v-model="forms.hedi05" />

                                                        <div v-if="errors.hedi05">
                                                            <div v-for="error in errors.hedi05" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>



                                                <div class="row mb-3">
                                                    <div class="col-lg-3">
                                                        <label for="defaultconfig" class="col-form-label">Hedi06</label>
                                                        <input type="text" class="form-control" id="hedi01" placeholder=""
                                                            v-model="forms.hedi06" />

                                                        <div v-if="errors.hedi06">
                                                            <div v-for="error in errors.hedi06" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Hedi07</label>
                                                        <input type="text" class="form-control" id="hedi02" placeholder=""
                                                            v-model="forms.hedi07" />

                                                        <div v-if="errors.hedi07">
                                                            <div v-for="error in errors.hedi07" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Hedi08</label>
                                                        <input type="text" class="form-control" id="hedi08" placeholder=""
                                                            v-model="forms.hedi08" />

                                                        <div v-if="errors.hedi08">
                                                            <div v-for="error in errors.hedi08" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Hedi09</label>
                                                        <input type="text" class="form-control" id="hedi09" placeholder=""
                                                            v-model="forms.hedi09" />

                                                        <div v-if="errors.hedi09">
                                                            <div v-for="error in errors.hedi09" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-3">
                                                        <label for="defaultconfig" class="col-form-label">Hedi10</label>
                                                        <input type="text" class="form-control" id="hedi10" placeholder=""
                                                            v-model="forms.hedi10" />

                                                        <div v-if="errors.hedi10">
                                                            <div v-for="error in errors.hedi10" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>


                                                <div class="row mb-3">
                                                    <div class="col-lg-3">
                                                        <label for="defaultconfig" class="col-form-label">Hedi11</label>
                                                        <input type="text" class="form-control" id="hedi11" placeholder=""
                                                            v-model="forms.hedi11" />

                                                        <div v-if="errors.hedi11">
                                                            <div v-for="error in errors.hedi11" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Hedi12</label>
                                                        <input type="text" class="form-control" id="hedi12" placeholder=""
                                                            v-model="forms.hedi12" />

                                                        <div v-if="errors.hedi12">
                                                            <div v-for="error in errors.hedi12" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Hedi13</label>
                                                        <input type="text" class="form-control" id="hedi13" placeholder=""
                                                            v-model="forms.hedi13" />

                                                        <div v-if="errors.hedi13">
                                                            <div v-for="error in errors.hedi13" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Hedi14</label>
                                                        <input type="text" class="form-control" id="hedi09" placeholder=""
                                                            v-model="forms.hedi14" />

                                                        <div v-if="errors.hedi14">
                                                            <div v-for="error in errors.hedi14" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-3">
                                                        <label for="defaultconfig" class="col-form-label">Hedi15</label>
                                                        <input type="text" class="form-control" id="hedi15" placeholder=""
                                                            v-model="forms.hedi15" />

                                                        <div v-if="errors.hedi15">
                                                            <div v-for="error in errors.hedi15" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>



                                                <div class="row mb-3">
                                                    <div class="col-lg-3">
                                                        <label for="defaultconfig" class="col-form-label">Hedi16</label>
                                                        <input type="text" class="form-control" id="hedi16" placeholder=""
                                                            v-model="forms.hedi16" />

                                                        <div v-if="errors.hedi16">
                                                            <div v-for="error in errors.hedi16" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Hedi17</label>
                                                        <input type="text" class="form-control" id="hedi17" placeholder=""
                                                            v-model="forms.hedi17" />

                                                        <div v-if="errors.hedi17">
                                                            <div v-for="error in errors.hedi17" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Hedi18</label>
                                                        <input type="text" class="form-control" id="hedi18" placeholder=""
                                                            v-model="forms.hedi18" />

                                                        <div v-if="errors.hedi18">
                                                            <div v-for="error in errors.hedi18" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Hedi19</label>
                                                        <input type="text" class="form-control" id="hedi19" placeholder=""
                                                            v-model="forms.hedi19" />

                                                        <div v-if="errors.hedi14">
                                                            <div v-for="error in errors.hedi19" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-3">
                                                        <label for="defaultconfig" class="col-form-label">Hedi20</label>
                                                        <input type="text" class="form-control" id="hedi20" placeholder=""
                                                            v-model="forms.hedi20" />

                                                        <div v-if="errors.hedi20">
                                                            <div v-for="error in errors.hedi20" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>

                                            </div>



                                        </div>




                                        <div class="card-footer">
                                            <button class="
        btn btn-warning
        text-black
        fw-bolder
        btn-icon-text
      " @click="backForm" type="button">
                                                <i class="link-icon" data-feather="arrow-left"></i>
                                                {{ $t("backMess") }}
                                            </button>
                                            &nbsp;&nbsp;&nbsp;
                                            <button class="btn btn-primary float-end btn-sm" type="submit">
                                                <i class="link-icon" data-feather="save"></i>
                                                Save All
                                            </button>
                                        </div>
                                    </form>

                                </div>
                            </div> <!--end::card-->
                        </div>
                    </div>
                </div>
                <!--end::content-->

                <!--begin::footer-->
                <footer-component></footer-component>
                <!--end::footer-->
            </div>
        </div>
    </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from "vue2-daterange-picker";
import multiselect from "vue-multiselect";
import { mask } from 'vue-the-mask'

export default {
    name: "CmlTarifAdd",
    props: {},
    directives: { mask },
    components: {
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        DateRangePicker,
        multiselect
    },
    data() {
        const startDate = new Date();// new Date();
        const endDate = new Date();

        return {
            dateFilter: {
                startDate,
                endDate,
            },

            expectedShipmentTime1dateFilter: {
                startDate,
                endDate,
            },

            requiredDeliveryTimedateFilter: {
                startDate,
                endDate,
            },

            opens: "center",
            locale: {
                format: "yyyy-mm-dd H:MM:ss",
            },

            localeDetail: {
                format: "yyyy-mm-dd",
            },

            highlighted: {

                dates: [ // Highlight an array of dates
                    new Date(),
                ],

            },

            digit: {
                decimal: ',',
                thousands: '.',
                prefix: ' ',
                suffix: '',
                precision: 5,
                masked: false
            },
            fetchStockCondition: [{
                code:'N',
                name:'N-Good'
            },{
                code:'Y',
                name:'Y-Not Good'
            }],
            detailSo: [],
            orderType: '',
            fetchOrderType: [],
            shelfLifeUnit: {},
            shelfLifeType: {},
            permision_role: [],
            isLoading: false,
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            errors: [],
            userData: "",
            userRole: "",
            companyCode: "",
            fetchStatus: ['ACTIVE', 'DEACTIVE'],
            fetchmultiWhFlag: ['Y', 'N'],
            fetchCustomer: [],
            fetchFulfillment: [],
            customer: "",
            fulfillment: "",
            fetchShelfLifeType: [],
            fetchShelfLifeUnit: [],
            fetchSku: [],
            activeFlag: false,
            shelfLifeFlag: false,
            kitFlag: false,
            freePickGift: false,
            forms: {},
        };
    },
    watch: {},
    methods: {



        loadCustomer() {

            const baseURI = this.$settings.endPointFluxOms + "v2/customer/get-data-company-oms";

            return this.$http
                .get(
                    baseURI, { timeout: 10000 }
                )
                .then((response) => {
                    this.fetchCustomer = response.data.datas.data;
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },


        loadFullfilment() {

            const baseURI = this.$settings.endPointFluxOms + "v2/fulfillment/get-data-fulfillment";

            return this.$http
                .get(
                    baseURI, { timeout: 10000 }
                )
                .then((response) => {
                    this.fetchFulfillment = response.data.datas.data;
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },


        loadOrderType() {
            const baseURI = this.$settings.endPointFluxOms + "v2/so/type?code&name";
            return this.$http
                .get(
                    baseURI, { timeout: 10000 }
                )
                .then((response) => {
                    this.fetchOrderType = response.data.datas;
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },


        loadStockCondition() {
            const baseURI = this.$settings.endPointFluxOms + "v2/sku/get-data-wms-code?type=DMG_FLG";
            return this.$http
                .get(
                    baseURI, { timeout: 10000 }
                )
                .then((response) => {
                    this.fetchStockCondition = response.data.datas.data;
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },



        loadSKU(params) {


            this.fetchSku = [];
            const baseURI = this.$settings.endPointFluxOms + "v2/sku/index" + params;
            return this.$http
                .get(
                    baseURI, { timeout: 10000 }
                )
                .then((response) => {
                    this.fetchSku = response.data.datas.data;
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },

        asyncSearchSku(ev) {
            const baseURI = this.$settings.endPointFluxOms + "v2/sku/get-data-sku?sku=" + ev;
            return this.$http.get(baseURI).then((response) => {
                this.fetchSku = response.data.datas.data;
            });
        },

        // asyncSearchSku(ev) {
        //   console.log();
        // // this.fetchSku=[];
        // // const baseURI = this.$settings.endPointFluxOms + "v2/sku/get-data-sku?sku=" + ev;

        // // return this.$http
        // //   .get(
        // //     baseURI, { timeout: 10000 }
        // //   )
        // //   .then((response) => {
        // //     this.fetchSku = response.data.datas;
        // //   }).catch(error => {

        // //     if (error.code == "ECONNABORTED") {
        // //       this.error("Please Check Your Internet Connection");
        // //     }

        // //   });
        // },

        updateStatus(id) {
            this.$swal({
                title: this.$t("areYouSure"),
                text: 'Update Status Order',
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    var formData = {
                        orderStatus: 'NEW',
                    };
                    const baseURI =
                        this.$settings.endPointFluxOms + "v2/so/update-status-order/" + id;
                    this.$http
                        .post(baseURI, formData, { timeout: 10000 })
                        .then((response) => {
                            this.loading();
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                window.location.href = "/flux-oms/so-outbound/";
                                //   this.loadItems();
                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                        }).catch((error) => {
                            this.loading();

                            if (error.code == "ECONNABORTED") {
                                this.error(this.$t("check_internet_connection_txt"));

                            } else {


                                if (error.code == "ECONNABORTED") {
                                    this.error(this.$t("check_internet_connection_txt"));

                                } else {

                                    if (error.response) {
                                        if (error.response.status === 422) {
                                            this.errors = error.response.data.errors;
                                            this.resultError(error.response.data.errors);
                                        } else if (error.response.status === 401) {
                                            this.logout();
                                        } else if (error.response.status === 403) {
                                            this.$router.push("/authorized-error");
                                        } else if (error.response.status === 500) {
                                            this.$router.push('/server-error');
                                        } else {
                                            this.$router.push('/page-not-found');
                                        }
                                    }

                                }

                            }
                        });
                } else {
                    this.isLoading = false;
                }
            });
        },

        loadData(id) {
            this.isLoading = true;
            const baseURI = this.$settings.endPointFluxOms + "v2/so/detail/" + id;

            return this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                this.isLoading = false;
                this.forms = response.data.datas;
                console.log(this.forms.orderStatus);
                this.customer = {
                    code: this.forms.customerId,
                    customer_id: this.forms.customer_id
                };

                var params = "?customerId=" + this.forms.customerId;
                this.loadSKU(params);

                this.fulfillment = {
                    fulfillment_center_id: this.forms.fulfillment.fulfillment_center_id,
                    code: this.forms.fulfillment.code,
                    name: this.forms.fulfillment.name,
                };

                this.dateFilter = {
                    startDate: this.forms.orderTime,
                    endDate: this.forms.orderTime

                },


                    this.expectedShipmentTime1dateFilter = {
                        startDate: this.forms.expectedShipmentTime1,
                        endDate: this.forms.expectedShipmentTime1
                    },

                    // this.requiredDeliveryTimedateFilter = {
                    //     startDate: this.forms.requiredDeliveryTime == null ? new Date() : this.forms.requiredDeliveryTime,
                    //     endDate: this.forms.requiredDeliveryTime == null ? new Date() : this.forms.requiredDeliveryTime,
                    // },



                    this.orderType = {
                        code: this.forms.order_type.code,
                        name: this.forms.order_type.name,
                    };

                this.detailSo = [];

                for (let index = 0; index < this.forms.so_details.length; index++) {

                    const element = {
                        "idOrderHeader": this.forms.so_details[index].idOrderHeader,
                        "orderLineNo": this.forms.so_details[index].orderLineNo,
                        "sku": {
                            sku: this.forms.so_details[index].sku
                        },
                        "skuDescr1":this.forms.so_details[index].skuDescr1,
                        "uom":this.forms.so_details[index].uom,
                        "lotAtt01":this.forms.so_details[index].lotAtt01,
                        "lotAtt02":this.forms.so_details[index].lotAtt02,
                        "lotAtt03":this.forms.so_details[index].lotAtt03,
                        "lotAtt04":this.forms.so_details[index].lotAtt04,
                        "lotAtt05":this.forms.so_details[index].lotAtt05,
                        "lotAtt06":this.forms.so_details[index].lotAtt06,
                        "lotAtt07":this.forms.so_details[index].lotAtt07,
                        "lotAtt08":{
                            code:this.forms.so_details[index].lotAtt08,
                            name:this.forms.so_details[index].lotAtt08,
                        },
                        "lotAtt09":this.forms.so_details[index].lotAtt09,
                        "lotAtt10":this.forms.so_details[index].lotAtt10,
                        "lotAtt11":this.forms.so_details[index].lotAtt11,
                        "lotAtt12":this.forms.so_details[index].lotAtt12,
                        "lotAtt13":this.forms.so_details[index].lotAtt13,
                        "lotAtt14":this.forms.so_details[index].lotAtt14,
                        "lotAtt15":this.forms.so_details[index].lotAtt15,
                        "lotAtt16":this.forms.so_details[index].lotAtt16,
                        "lotAtt17":this.forms.so_details[index].lotAtt17,
                        "lotAtt18":this.forms.so_details[index].lotAtt18,
                        "lotAtt19":this.forms.so_details[index].lotAtt19,
                        "lotAtt20":this.forms.so_details[index].lotAtt20,
                        "lotAtt21":this.forms.so_details[index].lotAtt21,
                        "lotAtt22":this.forms.so_details[index].lotAtt22,
                        "lotAtt23":this.forms.so_details[index].lotAtt23,
                        "lotAtt24":this.forms.so_details[index].lotAtt24,
                        "qtyOrdered":this.forms.so_details[index].qtyOrdered,
                        "price":this.forms.so_details[index].price,
                        "udf01":this.forms.so_details[index].udf01,
                        "udf02":this.forms.so_details[index].udf02,
                        "udf03":this.forms.so_details[index].udf03,
                        "udf04":this.forms.so_details[index].udf04,
                        "udf05":this.forms.so_details[index].udf05,
                        "udf06":this.forms.so_details[index].udf06,
                        "noteText":this.forms.so_details[index].noteText,
                        "dedi01":this.forms.so_details[index].dedi01,
                        "dedi02":this.forms.so_details[index].dedi02,
                        "dedi03":this.forms.so_details[index].dedi03,
                        "dedi04":this.forms.so_details[index].dedi04,
                        "dedi05":this.forms.so_details[index].dedi05,
                        "dedi06":this.forms.so_details[index].dedi06,
                        "dedi07":this.forms.so_details[index].dedi07,
                        "dedi08":this.forms.so_details[index].dedi08,
                        "dedi09":this.forms.so_details[index].dedi09,
                        "dedi10":this.forms.so_details[index].dedi10,
                        "dedi11":this.forms.so_details[index].dedi11,
                        "dedi12":this.forms.so_details[index].dedi12,
                        "dedi13":this.forms.so_details[index].dedi13,
                        "dedi14":this.forms.so_details[index].dedi14,
                        "dedi15":this.forms.so_details[index].dedi15,
                        "dedi16":this.forms.so_details[index].dedi16,
                        "dedi17":this.forms.so_details[index].dedi17,
                        "dedi18":this.forms.so_details[index].dedi18,
                        "dedi19":this.forms.so_details[index].dedi19,
                        "dedi20":this.forms.so_details[index].dedi20,
                    }

                    this.detailSo.push(element);

                }

                // this.fulfillment    = response.data.datas.fulfillment

            }).catch(error => {

                this.loading();

                if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
                } else {

                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        } else {
                            this.$router.push('/page-not-found');
                        }
                    }

                }

            });
        },

        cekData(index, fieldType) {
            console.log(index);
            console.log(fieldType);
            fieldType[index].skuDescr1 = fieldType[index].sku.skuDescr1;
            // fieldType[index].lading_length = fieldType[index].sku.pcs_length;
            // fieldType[index].lading_width = fieldType[index].sku.pcs_width;
            // fieldType[index].lading_height = fieldType[index].sku.pcs_height;
            // //fieldType[index].package_type = fieldType[index].sku.package_code;    
            // fieldType[index].lading_qty = fieldType[index].sku.lading_qty;
            // fieldType[index].net_weight = fieldType[index].sku.net_weight;
            // fieldType[index].weight = fieldType[index].sku.weight;
            // fieldType[index].volume = fieldType[index].sku.volume;
            // //fieldType[index].qty = 0;  
            // this.loadLadingType(fieldType[index].sku.sku_id);
        },


        asyncSearchFulfillment(ev) {
            this.fetchFulfillment = [];
            const baseURI = this.$settings.endPointFluxOms + "v2/fulfillment/get-data-fulfillment?code=" + ev;

            return this.$http
                .get(
                    baseURI, { timeout: 10000 }
                )
                .then((response) => {
                    this.fetchFulfillment = response.data.datas.data;
                    //console.log(this.fetchFulfillment);
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },


        asyncCustomer(code) {
            this.fetchCustomer = [];
            const baseURI = this.$settings.endPointFluxOms + "v2/customer/get-data-company-oms?code=" + code;

            return this.$http
                .get(
                    baseURI, { timeout: 10000 }
                )
                .then((response) => {
                    this.fetchCustomer = response.data.datas.data;
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },

        resetForm() {

            this.forms = [];

        },

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.userData = userDatas.sub;
            this.userRole = userDatas.sub.role;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'SoController') {
                    rolePermision = permision;
                    // console.log(permision);
                }
            });

            if (!rolePermision.method_update) {
                this.$router.push("/authorized-error");
            }

            this.permision_role = rolePermision;
            this.loadFullfilment();
            this.loadCustomer();
            this.loadOrderType();
            // this.loadStockCondition();
            // this.loadShelfLifeType();
            // this.loadShelfLifeUnit();

        },

        backForm() {
            window.location.href = "/flux-oms/so-outbound";
        },



        submitData() {
            this.isLoading = true;
            this.forms.customer_id = this.customer.customer_id;
            this.forms.customerId = this.customer.code;

            this.forms.fulfillment_center_id = this.fulfillment.fulfillment_center_id;
            this.forms.warehouseId = this.fulfillment.code;
            this.forms.orderType = this.orderType.code;
            this.forms.orderTime = this.$moment(String(this.dateFilter.startDate)).format('YYYY-MM-DD HH:mm:ss');

            this.forms.expectedShipmentTime1 = this.$moment(String(this.expectedShipmentTime1dateFilter.startDate)).format('YYYY-MM-DD HH:mm:ss');
            this.forms.requiredDeliveryTime = this.$moment(String(this.expectedShipmentTime1dateFilter.startDate)).format('YYYY-MM-DD HH:mm:ss');
            var DOC_ORDER_DETAILS = [];

            for (let index = 0; index < this.detailSo.length; index++) {
                const element = {
                    "orderLineNo": index + 1,
                    "sku":this.detailSo[index].sku.sku,
                    "skuDescr1":this.detailSo[index].sku.skuDescr1,
                    "uom":this.detailSo[index].uom,
                    "lotAtt01":this.detailSo[index].lotAtt01,
                    "lotAtt02":this.detailSo[index].lotAtt02,
                    "lotAtt03":this.detailSo[index].lotAtt03,
                    "lotAtt04":this.detailSo[index].lotAtt04,
                    "lotAtt05":this.detailSo[index].lotAtt05,
                    "lotAtt06":this.detailSo[index].lotAtt06,
                    "lotAtt07":this.detailSo[index].lotAtt07,
                    "lotAtt08":this.detailSo[index].lotAtt08.code,
                    "lotAtt09":this.detailSo[index].lotAtt09,
                    "lotAtt10":this.detailSo[index].lotAtt10,
                    "lotAtt11":this.detailSo[index].lotAtt11,
                    "lotAtt12":this.detailSo[index].lotAtt12,
                    "lotAtt13":this.detailSo[index].lotAtt13,
                    "lotAtt14":this.detailSo[index].lotAtt14,
                    "lotAtt15":this.detailSo[index].lotAtt15,
                    "lotAtt16":this.detailSo[index].lotAtt16,
                    "lotAtt17":this.detailSo[index].lotAtt17,
                    "lotAtt18":this.detailSo[index].lotAtt18,
                    "lotAtt19":this.detailSo[index].lotAtt19,
                    "lotAtt20":this.detailSo[index].lotAtt20,
                    "lotAtt21":this.detailSo[index].lotAtt21,
                    "lotAtt22":this.detailSo[index].lotAtt22,
                    "lotAtt23":this.detailSo[index].lotAtt23,
                    "lotAtt24":this.detailSo[index].lotAtt24,
                    "qtyOrdered":this.detailSo[index].qtyOrdered,
                    "price":this.detailSo[index].price,
                    "udf01":this.detailSo[index].udf01,
                    "udf02":this.detailSo[index].udf02,
                    "udf03":this.detailSo[index].udf03,
                    "udf04":this.detailSo[index].udf04,
                    "udf05":this.detailSo[index].udf05,
                    "udf06":this.detailSo[index].udf06,
                    "noteText":this.detailSo[index].noteText,
                    "dedi01":this.detailSo[index].dedi01,
                    "dedi02":this.detailSo[index].dedi02,
                    "dedi03":this.detailSo[index].dedi03,
                    "dedi04":this.detailSo[index].dedi04,
                    "dedi05":this.detailSo[index].dedi05,
                    "dedi06":this.detailSo[index].dedi06,
                    "dedi07":this.detailSo[index].dedi07,
                    "dedi08":this.detailSo[index].dedi08,
                    "dedi09":this.detailSo[index].dedi09,
                    "dedi10":this.detailSo[index].dedi10,
                    "dedi11":this.detailSo[index].dedi11,
                    "dedi12":this.detailSo[index].dedi12,
                    "dedi13":this.detailSo[index].dedi13,
                    "dedi14":this.detailSo[index].dedi14,
                    "dedi15":this.detailSo[index].dedi15,
                    "dedi16":this.detailSo[index].dedi16,
                    "dedi17":this.detailSo[index].dedi17,
                    "dedi18":this.detailSo[index].dedi18,
                    "dedi19":this.detailSo[index].dedi19,
                    "dedi20":this.detailSo[index].dedi20,
                    "rotationId":this.detailSo[index].rotationId,
                }

                DOC_ORDER_DETAILS.push(element);

            }

            this.forms.DOC_ORDER_DETAILS = DOC_ORDER_DETAILS;

            console.log(this.forms);
            var params = this.$onBehind(this.$route.params.id);
            const baseURI = this.$settings.endPointFluxOms + "v2/so/update/" + params[0];
            this.$http.patch(baseURI, this.forms, { timeout: 10000 }).then((response) => {
                this.loading();
                if (response.data.status === 200) {
                    //this.resetForm();
                    this.isLoading = false;
                    this.errors = [];
                    //console.log(response.data.datas.user_id);
                    //var params = this.$onRandom(response.data.datas.BAS_SKU_ID);
                    var params = this.$onRandom(this.forms.idOrderHeader);
                    window.location.href = "/flux-oms/so-outbound/detail/" + params;
                    this.success('Berhasil');
                } else {
                    this.isLoading = false;
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                }
            }).catch(error => {
                this.loading();
                this.isLoading = false;
                if (error.code == "ECONNABORTED") {
                    this.error("Please Check Your Internet Connection");
                }

                if (error.response) {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                        this.logout();
                    } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                    } else {
                        this.$router.push('/page-not-found');
                    }
                }
                //this.resetForm();
            });

        },


        addFieldDetail() {
            var userModels = JSON.parse(localStorage.getItem('userModels'));

            var params = "";
            if (userModels['sub']['fulfillments'] == null) {
                if (this.customer.customer_id == null) {
                    this.error("Please Select Company");

                } else {
                    params = "?customerId=" + this.customer?.code;
                    this.loadSKU(params);
                }


            } else {
                this.loadSKU(params);
            }

          
            this.detailSo.push({
         
         "sku": "",
         "skuDescr1": "",
         "qtyOrdered": 0,
         "price": 0,
         "lotAtt01": "",
         "lotAtt02": "",
         "lotAtt03": "",
         "lotAtt04": "",
         "lotAtt05": "",
         "lotAtt06": "",
         "lotAtt07": "",
         "lotAtt08":{
           code:'N',
           name:'N-Good'
         },
         "lotAtt09": "",
         "lotAtt10": "",
         "lotAtt11":"",
         "lotAtt12":"",
         "lotAtt13":"",
         "lotAtt14":"",
         "lotAtt15":"",
         "lotAtt16":"",
         "lotAtt17":"",
         "lotAtt18":"",
         "lotAtt19":"",
         "lotAtt20":"",
         "lotAtt21":"",
         "lotAtt22":"",
         "lotAtt23":"",
         "lotAtt24":"",
         "Uom": "",
         "udf01":"",
         "udf02":"",
         "udf03":"",
         "udf04":"",
         "udf05":"",
         "udf06":"",
         "noteText": "",
         "dedi01":"",
       "dedi02":"",
       "dedi03":"",
       "dedi04":"",
       "dedi05":"",
       "dedi06":"",
       "dedi07":"",
       "dedi08":"",
       "dedi09":0,
       "dedi10":0,
       "dedi11":"",
       "dedi12":"",
       "dedi13":"",
       "dedi14":"",
       "dedi15":"",
       "dedi16":"",
       "dedi17":"",
       "dedi18":"",
       "dedi19":"",
       "dedi20":""
       });

            console.log(this.detailSo);
        },

        removeField(index, fieldType) {
            fieldType.splice(index, 1);
        },

        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },
    },
    events: {},
    created: function () { },
    mounted() {
        this.fetchIt();

        var params = this.$onBehind(this.$route.params.id);
        this.loadData(params[0]);

    },
};
</script>
<style scoped>.required:after {
    content: " *";
    color: red;
}</style>